import { Component, OnInit } from '@angular/core';
import { AuthService } from 'libs/a2z-lib/src/lib/api/auth.api';
import { UserType } from './core/constants/common';

@Component({
  selector: 'school-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'school-admin';

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.authService.autoLogin(UserType);
  }
}
